import React from 'react';

import mainStyle from "../../dashboard.module.scss";
import { Box } from '@mui/material';

import PieChart from "components/PieChart";

import icn_pie_chart from 'assets/images/icons/icn_pie_chart.svg';

const UsagePieChart = ({ sortable, title, data, pieChartFormattedLegendName, handleLegendOnClick = null }) => (
  <div
    style={{ height: "214px" }}
    className={`main-card-content ${mainStyle["dndObj_card"]} ${sortable === true ? mainStyle["dndObj_edit"] : ""}`}
  >
    <div className={mainStyle['dndObj_title']}>
      <Box>
        <img src={icn_pie_chart} alt="icn_line_chart" />
      </Box>
      <span style={{ marginLeft: '10px' }}>{title}</span>
    </div>
    <PieChart
      pieGroupsData={data}
      height={160}
      formattedLegendName={pieChartFormattedLegendName}
      handleLegendOnClick={handleLegendOnClick}
    />
  </div>
)

export default UsagePieChart;
